// WS5 PR4a — Feature flag mobile FP (kill switch).
//
// Codex Q7 (WARNING): senza E2E real-device, un opt-out runtime riduce
// il rischio rollout. Override possibili (priorita' decrescente):
//   1. ?mobile-fp=off|on (URL query param, no persistenza).
//   2. localStorage `viewer:mobile-fp` = 'off'|'on'.
//   3. Default ON.
//
// Off → orchestrator non monta joystick/touch controls e re-applica il
// vecchio blocker walk-error reason='touch' (toast educational invariato).

const STORAGE_KEY = 'viewer:mobile-fp';
const QUERY_PARAM = 'mobile-fp';

export interface MobileFpFlagInputs {
  readonly search?: string;
  readonly storage?: Pick<Storage, 'getItem'>;
}

function readStorage(s?: Pick<Storage, 'getItem'>): 'on' | 'off' | null {
  if (s === undefined) return null;
  try {
    const v = s.getItem(STORAGE_KEY);
    if (v === 'on' || v === 'off') return v;
  } catch {
    // localStorage non disponibile (modalità privata Safari, file://, ecc.)
  }
  return null;
}

function readQuery(search?: string): 'on' | 'off' | null {
  if (search === undefined || search === '') return null;
  try {
    const params = new URLSearchParams(search);
    const v = params.get(QUERY_PARAM);
    if (v === 'on' || v === 'off') return v;
  } catch {
    // malformed query string → fall back a storage/default
  }
  return null;
}

// Codex iter2 Q14 (CRITICAL): in iframe sandboxati (es. embed in app
// con CSP restrittive) ANCHE l'accesso a window.localStorage property
// puo' throw SecurityError prima di entrare in getItem(). Avvolgi
// l'accesso al riferimento, non solo getItem().
function safeReadLocalStorage(): Pick<Storage, 'getItem'> | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

function safeReadLocationSearch(): string {
  if (typeof window === 'undefined') return '';
  try {
    return window.location.search;
  } catch {
    return '';
  }
}

export function isMobileFpEnabled(inputs?: MobileFpFlagInputs): boolean {
  const search = inputs?.search ?? safeReadLocationSearch();
  const storage = inputs?.storage ?? safeReadLocalStorage();
  const query = readQuery(search);
  if (query !== null) return query === 'on';
  const persisted = readStorage(storage);
  if (persisted !== null) return persisted === 'on';
  return true;
}
